/* eslint-disable no-unused-vars */
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { BifrostService } from "../../../service/bifrost-service";
import Types from "./types";
import { WHATSAPP_STAGE } from "../../../constants/app-constants";
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import { HTTP_CODES } from "../../../constants/app-constants";
import parseEChallanPaymentSummary from "../../../utils/parsers/parse-e-challan-payment-summary";
import { PROCESSING_STATUS } from "../../../constants/challan-constants";

const setRegNo = regNo => ({
    type: Types.SET_REG_NO,
    regNo
});

const setIsError = isError => ({
    type: Types.SET_IS_ERROR,
    isError
});

const setChallanDetails = challanDetails => ({
    type: Types.SET_CHALLAN_DETAILS,
    challanDetails
});

const setMaskedPhone = maskedPhone => ({
    type: Types.SET_MASKED_PHONE,
    maskedPhone
});

const setWhatsappConsent = whatsappConsent => ({
    type: Types.SET_WHATSAPP_CONSENT,
    whatsappConsent
});

const setIsMaxLimitReached = isMaxLimitReached => ({
    type: Types.SET_IS_MAX_LIMIT_REACHED,
    isMaxLimitReached
});

const setCartDetails = cartDetails => ({
    type: Types.SET_CART_DETAILS,
    cartDetails
});

const setCartResponse = cartResponse => ({
    type: Types.SET_CART_RESPONSE,
    cartResponse
});

const setRegistrationDetails = registrationDetails => ({
    type: Types.SET_REGISTRATION_DETAILS,
    registrationDetails
});

const setSelectedChallansList = selectedChallansList => ({
    type: Types.SET_SELECTED_CHALLANS_LIST,
    selectedChallansList
});

const verifyOtp = (params) => () => {
    const otp = params?.otp;
    const mobileNumber = params?.phone_number;
    return new Promise((resolve, reject) => {
        BifrostService.verifyOtp(otp, mobileNumber)
            .then(response => resolve(response))
            .catch(error => reject(error));
    });
};

const createChallanProspectLead = (payload, authToken) => dispatch => {
    dispatch(setIsMaxLimitReached(false));
    dispatch(setWhatsappConsent(true));
    return new Promise((resolve, reject) => {
        LeadServiceJava.createProspectLead(payload, authToken)
            .then(response => {
                dispatch(setMaskedPhone(response.data.detail.maskedPhone));
                resolve(response.data.detail);
            })
            .catch(error => {
                if (error && error.status === HTTP_CODES.BAD_REQUEST && error.message) {
                    dispatch(setIsMaxLimitReached(true));
                }
                reject(error);
            });
    });
};

const updateChallanProspectLead = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateProspectLead(payload)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getChallanProspectLeadDetails = (token, challanOtpEligblityCheckRequired = false) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getProspectLeadDetails(token, challanOtpEligblityCheckRequired)
            .then(response => {
                const registratonNo = response.data.detail.vehicleRegNo;
                const maskedPhone = response.data.detail.maskedPhone;
                const whatsappConsent = response.data.detail.whatsappConsent;
                const {
                    parivahanUrl = "",
                    rtoRegisteredPhoneMasked = "",
                    rtoRegisteredPhoneVerified = true,
                    preferentialLoginExperimentType = "",
                    preferentialLoginExperimentActiveV2 = false,
                    parivahanOtpExperimentActive = false,
                    parivahanOtpExperimentType = "",
                    parivahanOtpRequired = false
                } = response?.data?.detail || {};

                if (registratonNo) dispatch(setRegNo(registratonNo));
                if (maskedPhone) dispatch(setMaskedPhone(maskedPhone));
                if (whatsappConsent) dispatch(setWhatsappConsent(whatsappConsent === WHATSAPP_STAGE.STAGE_1 || whatsappConsent === WHATSAPP_STAGE.STAGE_2));
                dispatch(setRegistrationDetails({
                    parivahanUrl,
                    rtoRegisteredPhoneMasked,
                    rtoRegisteredPhoneVerified,
                    preferentialLoginExperimentType,
                    preferentialLoginExperimentActiveV2,
                    parivahanOtpExperimentActive,
                    parivahanOtpExperimentType,
                    parivahanOtpRequired
                }));
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getChallanList = ({ resetSelectedChallans, ...details }) => dispatch => {
    if (resetSelectedChallans) {
        dispatch(setSelectedChallansList([]));
    }
    dispatch(setChallanDetails({}));
    return new Promise((resolve, reject) => {
        LeadServiceJava.getChallanList({...details, isDesktop: true})
            .then(response => {
                if (response.data.detail.processingStatus === PROCESSING_STATUS.PROCESSED) {
                    dispatch(setChallanDetails(response.data.detail));
                }
                const {
                    parivahanUrl = "",
                    rtoRegisteredPhoneMasked = "",
                    rtoRegisteredPhoneVerified = true,
                    preferentialLoginExperimentType = "",
                    preferentialLoginExperimentActiveV2 = false,
                    parivahanOtpExperimentActive = false,
                    parivahanOtpExperimentType = "",
                    parivahanOtpRequired = false
                } = response?.data?.detail || {};

                dispatch(setRegistrationDetails({
                    parivahanUrl,
                    rtoRegisteredPhoneMasked,
                    rtoRegisteredPhoneVerified,
                    preferentialLoginExperimentType,
                    preferentialLoginExperimentActiveV2,
                    parivahanOtpExperimentActive,
                    parivahanOtpExperimentType,
                    parivahanOtpRequired
                }));
                resolve(response.data.detail);
            })
            .catch(error => {
                dispatch(setIsError(true));
                reject(error);
            });
    });
};

const checkLeadPhoneNumber = (data) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.checkLeadPhoneNumber(data)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

const sendOtpViaLeadToken = (token, sourceChannel) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.sendOtpViaLeadToken(token, sourceChannel)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

const verifyOtpViaLeadToken = (data) => (dispatch) => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.verifyOtpViaLeadToken(data)
            .then((response) => {
                resolve(response.data.detail);
            }).catch((error) => {
                reject(error);
            });
    });
};

const removeFromCart = (details) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.removeFromCart(details)
            .then(() => {
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
};

const emptyCart = (details) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.emptyCart(details)
            .then(() => {
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
};

const addToCart = (details) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.addToCart(details)
            .then(response => {
                resolve(response);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getCartDetails = (details) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getCartDetails(details)
            .then(response => {
                dispatch(setCartDetails(parseEChallanPaymentSummary(response.data)));
                dispatch(setCartResponse(response.data));
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const createOrder = (details) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.createOrder({...details, isDesktop: true, isChallan: true})
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const sendChallanVerificationOtp = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.sendChallanVerificationOtp(token, payload)
            .then((response) => {
                resolve(response.data.detail);
            }).catch(error => {
                reject(error);
            });
    });
};

const verifyChallanVerificationOtp = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.verifyChallanVerificationOtp(token, payload)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const sendMandateOtp = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.sendMandateOtp(token, payload)
            .then((response) => {
                resolve(response.data.detail);
            }).catch(error => {
                reject(error);
            });
    });
};

const verifyMandateOtp = (token, payload, prospectLeadToken) => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.verifyMandateOtp(token, payload, prospectLeadToken)
            .then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
    });
};

const getOrderByIdentifier = (token, payload) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.getOrderByIdentifier(token, payload)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    setRegNo,
    setIsError,
    createChallanProspectLead,
    getChallanProspectLeadDetails,
    getChallanList,
    checkLeadPhoneNumber,
    sendOtpViaLeadToken,
    verifyOtpViaLeadToken,
    verifyOtp,
    setMaskedPhone,
    updateChallanProspectLead,
    setWhatsappConsent,
    removeFromCart,
    emptyCart,
    addToCart,
    getCartDetails,
    createOrder,
    sendChallanVerificationOtp,
    verifyChallanVerificationOtp,
    sendMandateOtp,
    verifyMandateOtp,
    getOrderByIdentifier,
    setSelectedChallansList
};
